import React, { useEffect, useState } from "react";
import HeaderCustom from "../../../../components/HeaderCustom";
import { Backdrop, CircularProgress } from "@mui/material";
import '../../../../styles/AppCss.css'
import { getFiltrarGiftCard, getFiltrarUsuarios } from "../../../../api/ApiService";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import GiftCardTableComponent from "./components/GiftCardTableComponent";
import FitrosGiftCardComponents from "./components/FitrosGiftCardComponents";


export const statusOptions = [
    { label: 'Todos', value: "", id: 1 },
    { label: 'No usados', value: "no_usado", id: 2 },
];


function GiftCardPage() {
    const [loadingCargar, setLoadingCargar] = useState(false);
    const [loading, setLoading] = useState(false);

    const [dataGiftCard, setDataGiftCard] = useState([]);
    const [metaPaginacion, setMetaPaginacion] = useState({
        current_page: 1,
        per_page: 10,
        total: 0,
        last_page: 1
    });
    const [perPage, setPerPage] = useState(10);
    const [compradorDocumento, setCompradorDocumento] = useState('');
    const [beneficiarioDocumento, setBeneficiarioDocumento] = useState('');
    const [statusFilter, setStatusFilter] = useState('');

    //filtros
    const [fechaDesde, setFechaDesde] = useState('');
    const [fechaHasta, setFechaHasta] = useState('');

    const [usuariosData, setUsuariosData] = useState([]);
    const [loadingUsuarios, setLoadingUsuarios] = useState(false);
    const [buscarUsuario, setBuscarUsuario] = useState('');
    const [usuarioSelected, setUsuarioSelected] = useState(null);







    const stateToken = useSelector(state => state.reducerGlobal.token);
    const history = useNavigate();

    const handleApiFiltrarGiftCard = (
        page = 1,
        perPageValue = perPage,
        compradorDoc = compradorDocumento,
        beneficiarioDoc = beneficiarioDocumento,
        statusValue = statusFilter
    ) => {

        //    url: URL + `/listar/giftcards?uso=${body.uso}&documento_comprador=${body.documento_comprador}&documento_beneficiado=${body.documento_beneficiado}&per_page=${body.per_page}&page=${body.page}`,

        const body = {
            page: page,
            per_page: perPageValue,
            // documento_comprador: compradorDoc,
            // documento_beneficiado: beneficiarioDoc,
            documento_beneficiado: usuarioSelected?.ci || "",
            // uso: statusValue,
            fecha_desde: fechaDesde,
            fecha_hasta: fechaHasta,
            // usuario_id: usuarioSelected?.id || '',
        };
        console.log("body", body);

        setLoadingCargar(true);

        getFiltrarGiftCard(stateToken?.access_token, body)
            .then((response) => {

                setLoadingCargar(false);
                setLoading(true);

                if (response.data.length > 0) {
                    setDataGiftCard(response.data);
                } else {
                    setDataGiftCard([]);
                }

                setMetaPaginacion({
                    current_page: response?.current_page,
                    per_page: response?.per_page,
                    total: response?.total,
                    last_page: response?.last_page
                });
            })
            .catch((error) => {
                console.log("error==>getFiltrarGiftCard", error);
                setDataGiftCard([]);
                setLoading(true);
                setLoadingCargar(false);
            });
    };



























    const handleEditClick = (item) => {
        console.log('Edit', item);
        history(`/app/admin/paseo-plus/gift-card/detalle/${item?.codigo_giftcard}`);
    };

    //=============================================funcion para ver sin editar el local
    const handleVerGiftCard = (item) => {
        console.log('View', item);
        history(`/app/admin/paseo-plus/gift-card/detalle/${item?.codigo_giftcard}?mode=view`);
    };


    const handlePerPageChange = (newPerPage) => {
        setPerPage(newPerPage);
        // handleApiFiltrarGiftCard(1, newPerPage, compradorDocumento, beneficiarioDocumento, statusFilter);
    };

    const handleDescargarXlsx = () => {
        if (!dataGiftCard || dataGiftCard.length === 0) {
            alert("No hay datos para exportar.");
            return;
        }

        const filas = dataGiftCard.map((item) => ({
            "ID Carga": item?.codigo_giftcard || "-",
            "Fecha/hora": item?.fecha_compra_format || "-",
            "Usuario": item?.beneficiado_descripcion || "-",
            "Cédula": item?.comprador_ci || "-",
            "Monto": item?.saldo_format || "-",
            "Nro. de Ticket Bancard": item?.ticket_number || "-",
            "Nro. Tarjeta": item?.card_masked_number || "-",
            "Marca Tarjeta": item?.card_brand || "-",
            "Tipo Tarjeta": item?.card_type === 'credit' ? "Crédito" : "Débito",
            "Es Regalo": item?.es_regalo ? "Sí" : "No",
        }));

        const worksheet = XLSX.utils.json_to_sheet(filas);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "GiftCards");

        const fecha = new Date().toISOString().slice(0, 10);
        XLSX.writeFile(workbook, `giftcards_${fecha}.xlsx`);
    };

    const handleCompradorDocumentoChange = (value) => {
        setCompradorDocumento(value);
    };

    const handleBeneficiarioDocumentoChange = (value) => {
        setBeneficiarioDocumento(value);
    };

    const handleStatusChange = (value) => {
        setStatusFilter(value);
    };







    //============================================================ funcion para filtrar por estado y nombre
    const handleApiFiltrarUsuariosTituloEstado = () => {
        let body = {
            page: 1,
            per_page: 10,
            estado: "todos",
            term: buscarUsuario,
            email: "",
            verificacion: "",
            tipo: "todos",
            tester: "",

        };
        console.log("body", body);


        setLoadingUsuarios(true);

        getFiltrarUsuarios(stateToken?.access_token, body)
            .then(response => {
                console.log("response==>getFiltrarUsuarios", response);

                setLoadingUsuarios(false);
                // setMetaPaginacion(response.meta);

                if (response.data.length > 0) {
                    setUsuariosData(response.data);
                } else {
                    setUsuariosData([]);
                }



            })
            .catch(error => {
                console.log("error==>getFiltrarUsuarios", error);
                setUsuariosData([]);
                setLoadingUsuarios(false);
            })
    };


    useEffect(() => {
        const timeOutId = setTimeout(() => {
            if (buscarUsuario.length > 2) {

                handleApiFiltrarUsuariosTituloEstado();
            } else {
                // setUsuariosData();
            }
        }, 1500);
        return () => clearTimeout(timeOutId);

    }, [stateToken, buscarUsuario]);














    useEffect(() => {
        if (!stateToken) return;
        setLoading(true);
        handleApiFiltrarGiftCard(1, perPage, '', '', '');
    }, [stateToken, usuarioSelected]);

    useEffect(() => {
        if (!stateToken) return;
        const timeoutId = setTimeout(() => {
            handleApiFiltrarGiftCard(1, perPage, compradorDocumento, beneficiarioDocumento, statusFilter);
        }, 500);

        return () => clearTimeout(timeoutId);
    }, [compradorDocumento, beneficiarioDocumento, statusFilter, perPage]);








    //============================================================ funcion para filtrar por fechas: es nuevo
    useEffect(() => {
        if (!stateToken) return;

        if (fechaDesde || fechaHasta || usuarioSelected) {
            const timeoutId = setTimeout(() => {
                handleApiFiltrarGiftCard(1, perPage, compradorDocumento, beneficiarioDocumento, statusFilter);
            }, 500);

            return () => clearTimeout(timeoutId);
        }

    }, [fechaDesde, fechaHasta, usuarioSelected]);
























    return (
        <HeaderCustom>
            <div className="min-h-screen bg-gray-100 p-6">
                {loading ? (
                    <div>
                        <FitrosGiftCardComponents
                            title={'GiftCard - Compras'}
                            handleDescargarXlsx={handleDescargarXlsx}
                            compradorDocumento={compradorDocumento}
                            onCompradorDocumentoChange={handleCompradorDocumentoChange}
                            beneficiarioDocumento={beneficiarioDocumento}
                            onBeneficiarioDocumentoChange={handleBeneficiarioDocumentoChange}
                            statusFilter={statusFilter}
                            onStatusChange={handleStatusChange}
                            statusOptions={statusOptions}

                            fechaDesde={fechaDesde}
                            setFechaDesde={setFechaDesde}

                            fechaHasta={fechaHasta}
                            setFechaHasta={setFechaHasta}

                            usuariosData={usuariosData}
                            loadingUsuarios={loadingUsuarios}
                            buscarUsuario={buscarUsuario}
                            setBuscarUsuario={setBuscarUsuario}
                            usuarioSelected={usuarioSelected}
                            setUsuarioSelected={setUsuarioSelected}

                        />

                        <div>
                            <GiftCardTableComponent
                                data={dataGiftCard}
                                metaPaginacion={metaPaginacion}
                                onPageChange={handleApiFiltrarGiftCard}
                                perPage={perPage}
                                onPerPageChange={handlePerPageChange}
                                handleEditarItem={handleEditClick}
                                handleVerGiftCard={handleVerGiftCard}


                            />
                        </div>
                    </div>
                ) : (
                    <div className="bg-white rounded-xl shadow-md p-8">
                        <div className="h-6 bg-gray-200 rounded w-1/3 mb-6 animate-pulse" />
                        <div className="space-y-4">
                            <div className="h-10 bg-gray-200 rounded animate-pulse" />
                            <div className="h-10 bg-gray-200 rounded animate-pulse" />
                            <div className="h-24 bg-gray-200 rounded animate-pulse" />
                        </div>
                    </div>
                )}

                <Backdrop open={loadingCargar} sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}>
                    <CircularProgress color="inherit" />
                </Backdrop>
            </div>
        </HeaderCustom>
    );
}

export default GiftCardPage;